import { t } from 'ttag'
import { useState } from 'react'
import { useQuery } from 'react-query'

import { AddIcon } from '@h2/components/icons/add'
import { InviteUsersIcon } from '@h2/components/icons/inviteUsers'
import { LessonPlanIcon } from '@h2/components/icons/lessonPlan'
import { SLB, SO } from '@h2/components/colors'
import { CoverLetterIcon } from '@h2/components/icons/coverLetter'
import { api } from '@h2/api'

import { AssignmentDetail } from './detailModal'

import { OverviewItem } from '../../components/common/overview/overviewItem'
import { ThingsToAction } from '../common/overview/thingsToAction'
import { KeyStatistics } from '../common/overview/keyStatistics'
import { Overview } from '../common/overview'
import { addCommas } from '../../utils'

const AssignmentOverview = ({ dashboard, isFetching }) => {
  const uncomplete = dashboard?.assignments?.uncompletedAssignments
  const unapproved = dashboard?.assignments?.unapprovedAssignments
  const active = dashboard?.assignments?.activeLessons
  const completed = dashboard?.assignments?.completedAssignments
  const approved = dashboard?.assignments?.approvedAssignments
  const [showDetailModal, setShowDetailModal] = useState(false)
  const { data: apiData } = useQuery('lessonStates', () =>
    api.fetch('/navigator/assignments')
  )

  return (
    <Overview
      icon={CoverLetterIcon}
      title={t`Assignment`}
      dropdown={{
        text: t`Actions`,
        items: [
          {
            icon: AddIcon,
            text: t`Create a Lesson`,
            href: '/management/lessons/wizard'
          },
          {
            icon: InviteUsersIcon,
            text: t`Assign a Lesson`,
            href: '/management/users/assignLesson'
          },
          { icon: LessonPlanIcon, text: t`Manage Lessons`, href: '/management/lessons' }
        ]
      }}>
      <ThingsToAction>
        <OverviewItem isFetching={isFetching} width="50%">
          <OverviewItem.Heading color={SO}>
            {addCommas(uncomplete?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text>{t`Unfinished assignments`}</OverviewItem.Text>
          <OverviewItem.Button
            to={{
              pathname: '/management/assignments',
              state: { status: 1, userSelected: false }
            }}>
            {t`Review now`}
          </OverviewItem.Button>
        </OverviewItem>

        <OverviewItem isFetching={isFetching} width="50%">
          <OverviewItem.Heading color={SO}>
            {addCommas(unapproved?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text>{t`Unapproved assignments`}</OverviewItem.Text>
          <OverviewItem.Button
            to={{
              pathname: '/management/assignments',
              state: { status: 2, userSelected: false }
            }}>
            {t`Review now`}
          </OverviewItem.Button>
        </OverviewItem>
      </ThingsToAction>

      <KeyStatistics>
        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(active?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text size="small" align="center">
            {t`Distinct Lessons Assigned`}
          </OverviewItem.Text>
          <OverviewItem.Button
            to="#"
            onClick={() => setShowDetailModal(true)}
            color="blue">
            {t`View here`}
          </OverviewItem.Button>
        </OverviewItem>

        <AssignmentDetail
          openModal={showDetailModal}
          setOpenModal={setShowDetailModal}
          data={apiData}
        />
        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(completed?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text size="small" align="center">
            {t`Completed Assignments`}
          </OverviewItem.Text>
          <OverviewItem.Chart data={completed?.dataPoints} />
        </OverviewItem>

        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(approved?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text size="small" align="center">
            {t`Approved Assignments`}
          </OverviewItem.Text>
          <OverviewItem.Chart data={approved?.dataPoints} />
        </OverviewItem>
      </KeyStatistics>
    </Overview>
  )
}

export { AssignmentOverview }
